export default "__VITE_ASSET__69f25e28__"